<template>
    <article>
        <v-simple-table>
            <thead>
            <tr>
                <th>Argument</th>
                <th>Environment variable</th>
                <th>Default value</th>
                <th>Description</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="a in args">
                <td><var>{{a.name}}</var></td>
                <td><var>{{a.env}}</var></td>
                <td><var v-if="a.def">{{a.def}}</var></td>
                <td v-html="a.desc"></td>
            </tr>
            </tbody>
        </v-simple-table>
    </article>
</template>

<script>

export default {
    computed: {
        args() {
            return [
                {name: '--listen', env: 'LISTEN', def: '0.0.0.0:8080', desc: 'listen address - ip:port or :port'},
                {name: '--url-base-path', env: 'URL_BASE_PATH', def: '/', desc: 'the base URL to run Coroot at a sub-path, e.g. <var>/coroot/</var>'},
                {name: '--data-dir', env: 'DATA_DIR', def: '/data', desc: 'path to the data directory'},
                {name: '--cache-ttl', env: 'CACHE_TTL', def: '720h', desc: 'cache TTL'},
                {name: '--cache-gc-interval', env: 'CACHE_GC_INTERVAL', def: '10m', desc: 'cache GC interval'},
                {name: '--pg-connection-string', env: 'PG_CONNECTION_STRING', def: '', desc: 'Postgres connection string (sqlite is used if not set)'},
                {name: '--disable-usage-statistics', env: 'DISABLE_USAGE_STATISTICS', def: 'false', desc: 'disable usage statistics'},
                {name: '--read-only', env: 'READ_ONLY', def: 'false', desc: 'enable the read-only mode when configuration changes don\'t take effect'},
                {name: '--do-not-check-slo', env: 'DO_NOT_CHECK_SLO', def: 'false', desc: 'do not check SLO compliance'},
                {name: '--do-not-check-for-deployments', env: 'DO_NOT_CHECK_FOR_DEPLOYMENTS', def: 'false', desc: 'do not check for new deployments'},
                {name: '--do-not-check-for-updates', env: 'DO_NOT_CHECK_FOR_UPDATES', def: 'false', desc: 'do not check for new versions'},
                {name: '--auth-anonymous-role', env:'AUTH_ANONYMOUS_ROLE', def: '', desc:'Disable authentication and assign one of the following roles to the anonymous user: Admin, Editor, or Viewer'},
                {name: '--auth-bootstrap-admin-password', env:'AUTH_BOOTSTRAP_ADMIN_PASSWORD', def:'', desc: 'Password for the default Admin user'},
                {name: '--license-key', env:'LICENSE_KEY', def:'', desc: 'The license key for Coroot Enterprise Edition'},

            ];
        },
    }
}
</script>

<style scoped>
</style>
